import { call, put, all, select, putResolve } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  add as addHomeLayout
} from '../redux/layouts'
import {
  addArray as addLayoutGroupArray
} from '../redux/layoutGroups'
import {
  addArray as addBoardArray
} from 'store/redux/boards'
import fetchPermissionLevelForLayout from './fetchPermissionLevelForLayout'
import viewError from 'store/sagas/viewError'

export default function * fetchHomeLayout (action) {
  const { layoutId } = action.payload

  try {
    const [
      Layout
    ] = yield all([
      call(apiGetData, 'HomeLayout', {
        layoutId
      }),
      call(fetchPermissionLevelForLayout, { payload: { layoutId }})
    ])

    const batchedActions = []

    // Board groups
    const boards = []
    const layoutGroupIds = []
    const layoutGroups = []

    Layout.Layout.forEach(LayoutGroup => {
      const layoutGroup = {
        key: `${layoutId}-${LayoutGroup.Id}`,
        id: LayoutGroup.Id,
        name: LayoutGroup.Name,
        elements: LayoutGroup.Elements.map(LayoutGroupElement => {
          let layoutGroupElement = {
            id: LayoutGroupElement.Id,
            name: LayoutGroupElement.Name,
            type: LayoutGroupElement.Type
          }

          if (LayoutGroupElement.Type === 'board') {
            layoutGroupElement = {
              ...layoutGroupElement,
              boardId: LayoutGroupElement.BoardId
            }

            boards.push({
              id: LayoutGroupElement.BoardId,
              name: LayoutGroupElement.Name,
              background: LayoutGroupElement.Background,
              isObserved: LayoutGroupElement.IsObserved,
              hasAccess: LayoutGroupElement.Accessible,
              isClosed: LayoutGroupElement.IsClosed,
              isTemplate: LayoutGroupElement.IsTemplate,
              isLocked: LayoutGroupElement.IsLocked,
              isPublic: LayoutGroupElement.IsPublic,
              permissionLevel: LayoutGroupElement.PermissionLevel
            })
          } else if (LayoutGroupElement.Type === 'link') {
            layoutGroupElement = {
              ...layoutGroupElement,
              url: LayoutGroupElement.Url
            }
          }

          return layoutGroupElement
        })
      }

      layoutGroupIds.push(layoutGroup.id)
      layoutGroups.push(layoutGroup)
    })

    batchedActions.push(addBoardArray(boards))

    batchedActions.push(addLayoutGroupArray(layoutGroups))

    batchedActions.push(addHomeLayout({
      id: Layout.Id,
      name: Layout.Name,
      description: Layout.Description,
      isPublic: Layout.IsPublic,
      isShared: Layout.IsShared,
      isTemplate: Layout.IsTemplate,
      layoutGroups: layoutGroupIds,
    }))

    yield put(batchedActions)
  } catch (error) {
    if (error.code === 401) {
      const state = yield select()
      yield putResolve(viewError({
        text: state.kanbo.locale.messages['DESK_NOT_FOUND']
      }))
    } else if (error.code === 601) {
      const state = yield select()
      yield putResolve(viewError({
        text: state.kanbo.locale.messages['DESK_ACCESS_DENIED']
      }))
    } else {
      throw error
    }
  }
}
